import { motion } from 'framer-motion';

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPortfolio = (e) => {
    e.preventDefault();
    const element = document.querySelector('#portfolio');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="pt-20 bg-cream"
      data-testid="hero-section"
    >
      {/* Split Layout: Image Left, Text Right */}
      <div className="grid lg:grid-cols-2 min-h-[calc(100vh-80px)]">
        {/* Image Side */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="relative h-[50vh] lg:h-full"
        >
          <img
            src="https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=1200&q=80"
            alt="Elegant bride in wedding dress"
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Content Side */}
        <div className="flex items-center justify-center p-8 lg:p-16">
          <div className="max-w-xl">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="font-sans text-xs tracking-superwide text-terracotta mb-6"
            >
              PHOTOGRAPHY & VIDEOGRAPHY
            </motion.p>
            
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="font-serif text-5xl sm:text-6xl lg:text-7xl text-charcoal tracking-tight leading-none mb-8"
            >
              Moments<br />
              <span className="italic font-normal">that matter.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="font-body text-base lg:text-lg text-stone leading-relaxed mb-10"
            >
              Every frame is intentional. We craft visual stories for brands and milestones that deserve to be remembered.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="flex flex-col sm:flex-row gap-4"
            >
              <a
                href="#portfolio"
                onClick={scrollToPortfolio}
                className="font-sans text-xs tracking-widest border border-charcoal text-charcoal px-8 py-4 hover:bg-charcoal hover:text-cream transition-all duration-300 text-center"
                data-testid="hero-view-work"
              >
                VIEW OUR WORK
              </a>
              <a
                href="#contact"
                onClick={scrollToContact}
                className="font-sans text-xs tracking-widest bg-terracotta text-cream px-8 py-4 hover:bg-charcoal transition-colors duration-300 text-center"
                data-testid="hero-book-session"
              >
                BOOK A SESSION
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
